import { gql } from '@/__generated__';

export const ARE_ALERTS_DISABLED = gql(`#graphql
  query AreAlertsDisabled($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      alerts {
        id
        activeConfigurations {
          id
        }
      }
    }
  }
`);
